import { render, staticRenderFns } from "./ChangePriorityConfig.vue?vue&type=template&id=3216a1dd&scoped=true"
import script from "./ChangePriorityConfig.vue?vue&type=script&lang=js"
export * from "./ChangePriorityConfig.vue?vue&type=script&lang=js"
import style0 from "./ChangePriorityConfig.vue?vue&type=style&index=0&id=3216a1dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3216a1dd",
  null
  
)

export default component.exports